'use client';

import { useTranslation } from 'react-i18next';
import { ElevationProvider } from '@web-store-platforms/providers/elevation';
import { ConsentProvider } from '../../context/ConsentContext';
import { useConsent } from '../../hooks/useConsent';
import { ConsentOverlay } from './ConsentOverlay';
import { LOGIN_CONSENT_ELEVATION_BASE } from './LoginConsentGate.consts';

export function LoginConsentGate({ children }: React.PropsWithChildren): React.ReactElement {
  const { t } = useTranslation();
  const {
    hasConsent,
    isConsentRequired,
    isConsentV2,
    shouldShowAlert,
    isAlertShaking,
    handleConsentChange,
    handleOverlayClick,
    shakeConsent,
  } = useConsent();

  const showConsentOverlay = isConsentRequired && !hasConsent;
  const overlayProps = isConsentV2
    ? { onOverlayClick: shakeConsent, isTransparent: true, title: t('login.consentRequiredTooltip') }
    : { onOverlayClick: handleOverlayClick };

  return (
    <ElevationProvider baseZIndex={LOGIN_CONSENT_ELEVATION_BASE}>
      <ConsentProvider
        value={{
          hasConsent,
          isConsentRequired,
          isConsentV2,
          shouldShowAlert,
          isAlertShaking,
          handleConsentChange,
          handleOverlayClick,
        }}
      >
        {showConsentOverlay && <ConsentOverlay {...overlayProps} />}
        <ElevationProvider>{children}</ElevationProvider>
      </ConsentProvider>
    </ElevationProvider>
  );
}
